import { Button } from "@/lib/shadcn/ui/button";

/**
 * Save with the reason it is blocked attached to it, so the two cannot be
 * rendered apart. The reason is a real element the button points at rather than
 * mere proximity — assistive tech has no notion of "the text next to it".
 *
 * The button is marked blocked with `aria-disabled`, NOT the native `disabled`
 * attribute: a natively disabled control leaves the tab sequence entirely, so an
 * operator tabbing field-to-field never lands on it and the reason it describes
 * is never announced — the control simply vanishes mid-tab (WCAG 3.3.1 / 4.1.2).
 * Staying focusable means it can also be clicked, so the refusal lives in the
 * click handler; that guard is the whole reason this lives in ONE component
 * rather than being copied into each page that needs it.
 */
export function SaveChangesButton({
    reasonId,
    reason,
    onClick,
}: {
    reasonId: string;
    reason?: string;
    onClick: () => void;
}) {
    const blocked = reason !== undefined;
    return (
        <div className="flex flex-col items-end gap-1">
            <Button
                aria-disabled={blocked}
                aria-describedby={blocked ? reasonId : undefined}
                className={blocked ? "opacity-50" : undefined}
                onClick={() => {
                    if (blocked) {
                        return;
                    }
                    onClick();
                }}
            >
                Save Changes
            </Button>
            {blocked && (
                <p id={reasonId} data-testid={reasonId} className="text-sm text-muted-foreground">
                    {reason}
                </p>
            )}
        </div>
    );
}

export default SaveChangesButton;
